var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.code.length > 0)?_c('div',{staticClass:"codewrapper"},[(_vm.link.length > 0)?_c('span',{staticClass:"codelink",on:{"click":function($event){return _vm.openEmbeddedIframe(_vm.link)}}},[_vm._v(_vm._s(_vm.code))]):_c('span',{staticClass:"codetext"},[_vm._v(_vm._s(_vm.code))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }